import { JobActions, JobActionTypes } from '../actions/job-status.actions';

export interface JobState {
  data: number; // Update this type with the actual data type returned by JoblockService.getCurrentLoadPercentage()
  error: any;
}

const initialState: JobState = {
  data: 0,
  error: null,
};

export function jobReducer(state = initialState, action: JobActions): JobState {
  switch (action.type) {
    case JobActionTypes.JOB_STATUS:
      return {
        ...state,
      };
    case JobActionTypes.JOB_STATUS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };
    case JobActionTypes.JOB_STATUS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
